/* Cocina Inoxidable: contador, carruseles y barra descartable. */

if (!customElements.get('ci-countdown')) {
  class CiCountdown extends HTMLElement {
    connectedCallback() {
      this.tz = this.dataset.tz || '-03:00';
      if (this.dataset.mode === 'daily') {
        this.end = this.nextDaily();
      } else {
        const raw = (this.dataset.end || '').trim();
        if (!raw) return this.expire();
        const iso = raw.replace(' ', 'T') + (raw.length <= 16 ? ':00' : '') + this.tz;
        this.end = new Date(iso).getTime();
      }
      if (isNaN(this.end)) return this.expire();
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    // Próxima vez que el reloj de la tienda marque la hora de corte (misma para todos los visitantes).
    nextDaily() {
      const [hh, mm] = (this.dataset.time || '23:59').split(':').map((n) => parseInt(n, 10) || 0);
      const sign = this.tz.startsWith('-') ? -1 : 1;
      const [oh, om] = this.tz.replace(/^[+-]/, '').split(':').map((n) => parseInt(n, 10) || 0);
      const offsetMs = sign * (oh * 60 + om) * 60000;
      const nowShop = new Date(Date.now() + offsetMs);
      let target = Date.UTC(nowShop.getUTCFullYear(), nowShop.getUTCMonth(), nowShop.getUTCDate(), hh, mm, 0) - offsetMs;
      if (target <= Date.now()) target += 86400000;
      return target;
    }
    tick() {
      let diff = Math.floor((this.end - Date.now()) / 1000);
      if (diff <= 0 && this.dataset.mode === 'daily') {
        this.end = this.nextDaily();
        diff = Math.floor((this.end - Date.now()) / 1000);
      }
      if (diff <= 0) return this.expire();
      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      const pad = (n) => String(n).padStart(2, '0');
      if (this.h) this.h.textContent = pad(h);
      if (this.m) this.m.textContent = pad(m);
      if (this.s) this.s.textContent = pad(s);
      this.hidden = false;
    }
    expire() {
      clearInterval(this.timer);
      this.hidden = true;
    }
  }
  customElements.define('ci-countdown', CiCountdown);
}

if (!customElements.get('ci-slider')) {
  class CiSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prev && this.prev.addEventListener('click', () => this.go(-1));
      this.next && this.next.addEventListener('click', () => this.go(1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();

      const autoplay = parseInt(this.dataset.autoplay || '0', 10);
      if (autoplay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay(autoplay);
        this.addEventListener('mouseenter', () => clearInterval(this.auto));
        this.addEventListener('mouseleave', () => this.startAutoplay(autoplay));
        this.addEventListener('focusin', () => clearInterval(this.auto));
      }
    }
    disconnectedCallback() {
      clearInterval(this.auto);
    }
    startAutoplay(seconds) {
      clearInterval(this.auto);
      this.auto = setInterval(() => {
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        atEnd ? this.goTo(0) : this.go(1);
      }, seconds * 1000);
    }
    slides() {
      return Array.from(this.track.children);
    }
    step() {
      const first = this.slides()[0];
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    go(dir) {
      if (this.dataset.loop === 'true') {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (dir > 0 && this.track.scrollLeft >= max - 4) return this.goTo(0);
        if (dir < 0 && this.track.scrollLeft <= 4) return this.goTo(this.slides().length - 1);
      }
      const perView = this.dataset.page === 'true' ? Math.max(1, Math.floor(this.track.clientWidth / this.step())) : 1;
      this.track.scrollBy({ left: dir * this.step() * perView, behavior: 'smooth' });
    }
    goTo(i) {
      this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4 && this.dataset.loop !== 'true';
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4 && this.dataset.loop !== 'true';
      if (this.dots.length) {
        const index = Math.round(this.track.scrollLeft / this.step());
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      }
    }
  }
  customElements.define('ci-slider', CiSlider);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-ci-dismiss]');
  if (!button) return;
  const target = document.getElementById(button.dataset.ciDismiss);
  if (!target) return;
  target.hidden = true;
  try {
    sessionStorage.setItem('ci-dismiss-' + button.dataset.ciDismiss, '1');
  } catch (e) {}
});

document.querySelectorAll('[data-ci-dismissable]').forEach((el) => {
  try {
    if (sessionStorage.getItem('ci-dismiss-' + el.id) === '1') el.hidden = true;
  } catch (e) {}
});

/* Fecha de hoy en la etiqueta de oferta de la ficha */
(function () {
  function fill() {
    var els = document.querySelectorAll('[data-ci-today]');
    if (!els.length) return;
    var txt = new Date().toLocaleDateString('es-CL', { day: 'numeric', month: 'long' });
    els.forEach(function (el) { el.textContent = txt; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  document.addEventListener('shopify:section:load', fill);
})();

/* Botón ancho: sube hasta el bloque de compra */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ci-scroll-buy]');
    if (!a || a.getAttribute('href') !== '#MainContent') return;
    var form = document.querySelector('product-info, .product__info-wrapper');
    if (!form) return;
    e.preventDefault();
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* Barra de compra fija: aparece al pasar el botón principal y lo reutiliza */
(function () {
  function init() {
    var bar = document.querySelector('[data-ci-sticky]');
    var main = document.querySelector('product-form .product-form__submit');
    if (!bar || !main || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    });
    io.observe(main);
    bar.querySelector('[data-ci-sticky-buy]').addEventListener('click', function () {
      if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      main.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
